import { render, staticRenderFns } from "./kkdayorder.vue?vue&type=template&id=97e86ae4&scoped=true"
import script from "./kkdayorder.vue?vue&type=script&lang=js"
export * from "./kkdayorder.vue?vue&type=script&lang=js"
import style0 from "./kkdayorder.vue?vue&type=style&index=0&id=97e86ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e86ae4",
  null
  
)

export default component.exports